export const PLACEMENTS = {
  TOP_RIGHT: 'top-right',
  TOP_LEFT: 'top-left',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_LEFT: 'bottom-left',
} as const;

export type Placement = (typeof PLACEMENTS)[keyof typeof PLACEMENTS];
